import {
  getArticleFeedbackRequest,
  getArticleFeedbackResponse,
  putArticleFeedbackRequest,
  removeArticleFeedbackRequest,
  reportArticleRequest,
} from "./feedback.dto";
import { apiV2 } from "./v2";

export const getArticleFeedbackApi = apiV2("GET", "/articles/:alias/:articleId/feedback")
  .withRequest(getArticleFeedbackRequest)
  .withResponse(getArticleFeedbackResponse);

export const putArticleFeedbackApi = apiV2("PUT", "/articles/:alias/:articleId/feedback").withRequest(putArticleFeedbackRequest);

export const removeArticleFeedbackApi = apiV2("DELETE", "/articles/:alias/:articleId/feedback").withRequest(removeArticleFeedbackRequest);

export const reportArticleApi = apiV2("PUT", "/articles/:alias/:articleId/report").withRequest(reportArticleRequest);
